import React, { useState } from 'react';
import { CampaignProps } from './types/propTypes';
import IconSvg from 'src/components/common/ui/IconSvg';

const objectives = [
  { name: 'Brand Awareness', icon: '🎯', objective: 'OUTCOME_AWARENESS' },
  { name: 'Leads', icon: '📈', objective: 'OUTCOME_LEADS' },
  { name: 'Sales', icon: '🛒', objective: 'OUTCOME_SALES' },
  // { name: 'Engagement', icon: '🤝', objective: 'OUTCOME_ENGAGEMENT' },
  // { name: 'Traffic', icon: '🚦', objective: 'OUTCOME_TRAFFIC' },
  // { name: 'App Promotion', icon: '📱', objective: 'OUTCOME_APP_PROMOTION' },
];


const CategorySelection: React.FC<CampaignProps> = ({ setCampaignData, campaignData }) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>('Brand Awareness');
  const handleCategoryClick = (category: { name: string; objective: string }) => {
    setSelectedCategory(category.name);
    setCampaignData({ ...campaignData, campaignObjective: category.objective, campaignCategory: category.name });
  };
  return (
    <div className="my-8 p-6 border border-[#E5E7E7] rounded-2xl">
      <h2 className="text-[28px] text-center font-semibold text-black mb-10">
        {/* What Category Does Your Campaign Fall Under? */}
        What is the objective of your campaign?
      </h2>
      <div className="flex justify-center gap-6 flex-wrap">
        {objectives.map(category => (
          <div
            key={category.name}
            className="p-4 cursor-pointer text-center"
            onClick={() => handleCategoryClick(category)}
          >
            <div className="mb-2">
              {selectedCategory === category.name ? (
                <div className="bg-[#6277FF] w-[132px] h-[132px] rounded-full flex items-center justify-center mx-auto">
                  <IconSvg icon="objectiveWhite" />
                </div>
              ) : (
                <div className="bg-[#F7F5FF] w-[132px] h-[132px] rounded-full flex items-center justify-center mx-auto">
                  <IconSvg icon="objectiveBlue" />
                </div>
              )}
            </div>

            <p className="font-normal text-black font-inter text-lg mt-3">{category.name}</p>
          </div>
        ))}
      </div>

    </div>
  );
};

export default CategorySelection;
